import _ from "lodash";
import { ELEMENTS } from "../../components/Element";

var initial_state: any = {
  builder: false,
  view: null,
};

export default function builderReducer(state = initial_state, action: any) {
  let view: any = { ...state.view };
  switch (action.type) {
    case "SET_DOCUMENT":
      return { ...state, view: action.document };
    case "BUILDER_MODE":
      return { ...state, builder: action.builder };
    case "SET_VIEW":
      return {
        ...state,
        view: _.set(view, action.path, action.value),
      };
    case "REMOVE_VIEW":
      return {
        ...state,
        view: _.omit(view, action.path),
      };
    case "DRAG_END_VIEW":
      let { source, destination } = action.result;
      if (destination) {
        let drag_item = null;
        if (source.droppableId == "elements") {
          drag_item = {
            key: ELEMENTS[source.index].element,
            value: {
              key:
                ELEMENTS[source.index].element +
                "#" +
                destination.droppableId +
                "-" +
                destination.index,
              ...ELEMENTS[source.index].value,
            },
          };
        } else {
          let droppableKey: string = Object.keys(view.data[source.droppableId])[
            source.index + 1
          ];
          let droppableValue: any = Object.values(
            view.data[source.droppableId]
          )[source.index + 1];
          drag_item = {
            key: droppableKey,
            value: {
              key:
                droppableKey +
                "#" +
                destination.droppableId +
                "-" +
                destination.index,
              ...droppableValue,
            },
          };
        }

        if (drag_item) {
          if (source.droppableId !== "elements")
            delete view.data[source.droppableId][drag_item.key];

          let drag_line_keys = Object.keys(view.data[destination.droppableId]);
          let drag_line_values = Object.values(
            view.data[destination.droppableId]
          );

          drag_line_keys = [
            ...drag_line_keys.slice(0, destination.index + 1),
            drag_item.key,
            ...drag_line_keys.slice(destination.index + 1),
          ];

          drag_line_keys = drag_line_keys.map((key, index) => {
            if (index !== 0) {
              let name = key;
              if (key.indexOf("$") > 0) name = key.slice(0, key.indexOf("$"));
              return name + "$" + index;
            } else {
              return key;
            }
          });

          drag_line_values = [
            ...drag_line_values.slice(0, destination.index + 1),
            drag_item.value,
            ...drag_line_values.slice(destination.index + 1),
          ];

          let drag_line = {};
          drag_line_keys.map((key: string, index: number) => {
            drag_line = { ...drag_line, [key]: drag_line_values[index] };
          });

          view.data[destination.droppableId] = drag_line;
        }
        return {
          ...state,
          view,
        };
      }
      return {
        ...state,
      };
    case "ADD_LINE":
      let add_line_view = [
        ...view.data.slice(0, action.order),
        { title: "" },
        ...view.data.slice(action.order),
      ];
      return {
        ...state,
        view: _.set(view, "data", add_line_view),
      };
    case "REMOVE_LINE":
      let remove_line_view = [
        ...view.data.slice(0, action.order),
        ...view.data.slice(action.order + 1),
      ];
      return {
        ...state,
        view: _.set(view, "data", remove_line_view),
      };
    case "MOVE_LINE":
      let item = view.data[action.order];
      let move_item = view.data[action.move_order];
      view.data[action.order] = move_item;
      view.data[action.move_order] = item;
      return {
        ...state,
        view,
      };
    default:
      return state;
  }
}
